angular.module("digitalLeasing.module").component("clientData", {
  templateUrl: "ng/components/digitalLeasing/clientData/clientData.view.html",
  bindings: {
    model: "=",
    cervedDataOk: "&?",
    viewIndex: "=",
    snapshot: '<',
    validatePage: '&',
    invalidatePage: '&',
    cciaaPvIsOptional: "<",
    vendor: '<'
  },
  controllerAs: "ClientDataCtrl",
  controller: ClientDataController
});

function ClientDataController(RiUserG, RiUserF, Residenza, $giuridicVersion) {
  var self = this;

  self.$onInit = function () {
    self.showCervedInfos = false;
    self.nuarc = false;
    jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("scrollTo", 0); //posiziona la scollBar in top ad ogni cambio vista
    self.supportModel = {
      callToCerved: false,
      riUserGFromCerved: {},
      isBackButton: false
    };

  };

  self.updateModelFromCerved = function (riUserG) {
    if (!self.modifyTestModalInNsil) {
      riUserG.updateFromCerved = true;
    }
    Object.keys(riUserG).forEach(function (value) {
      if ((riUserG[value] == null || riUserG[value] == "") && self.model.metadata.riUserG.formaGiuridica != 'PEF') {
        riUserG[value] = self.model.metadata.riUserG[value];
      }

      riUserG.sedeLegale.indirizzo = riUserG.sedeLegale.indirizzo.replace('.', ' ');
      Object.keys(riUserG.sedeLegale).forEach(function (value) {
        if (riUserG.sedeLegale[value] == null || riUserG.sedeLegale[value] == "") {
          riUserG.sedeLegale[value] = self.model.metadata.riUserG.sedeLegale[value];
        }
      });
      /*       if (riUserG.sedeConsegna) {
        Object.keys(riUserG.sedeConsegna).forEach(function (value) {
          if (riUserG.sedeConsegna[value] == null || riUserG.sedeConsegna[value] == "") {
            riUserG.sedeConsegna[value] = self.model.metadata.riUserG.sedeLegale[value];
          }
        });


        if (riUserG.sedeConsegna.luogoEsteso.nome == null || riUserG.sedeConsegna.luogoEsteso.nome == '') {
          riUserG.sedeConsegna.luogoEsteso.nome = self.model.metadata.riUserG.sedeLegale.luogoEsteso.nome;
        }

        if (riUserG.sedeConsegna.luogoEsteso.cap == null || riUserG.sedeConsegna.luogoEsteso.cap == '' || riUserG.sedeConsegna.luogoEsteso.cap.length == 0) {
          riUserG.sedeConsegna.luogoEsteso.cap = self.model.metadata.riUserG.sedeLegale.luogoEsteso.cap;
        }

        if (riUserG.sedeConsegna.luogoEsteso.sigla == null || riUserG.sedeConsegna.luogoEsteso.sigla == '') {
          riUserG.sedeConsegna.luogoEsteso.sigla = self.model.metadata.riUserG.sedeLegale.luogoEsteso.sigla;
        }

      }
      if (riUserG.sedeFatturazione) {
        Object.keys(riUserG.sedeFatturazione).forEach(function (value) {
          if (riUserG.sedeFatturazione[value] == null || riUserG.sedeFatturazione[value] == "") {
            riUserG.sedeFatturazione[value] = self.model.metadata.riUserG.sedeLegale[value];
          }
        });

        if (riUserG.sedeFatturazione.luogoEsteso.nome == null || riUserG.sedeFatturazione.luogoEsteso.nome == '') {
          riUserG.sedeFatturazione.luogoEsteso.nome = self.model.metadata.riUserG.sedeLegale.luogoEsteso.nome;
        }

        if (riUserG.sedeFatturazione.luogoEsteso.cap == null || riUserG.sedeFatturazione.luogoEsteso.cap == '' || riUserG.sedeFatturazione.luogoEsteso.cap.length == 0) {
          riUserG.sedeFatturazione.luogoEsteso.cap = self.model.metadata.riUserG.sedeLegale.luogoEsteso.cap;
        }

        if (riUserG.sedeFatturazione.luogoEsteso.sigla == null || riUserG.sedeFatturazione.luogoEsteso.sigla == '') {
          riUserG.sedeFatturazione.luogoEsteso.sigla = self.model.metadata.riUserG.sedeLegale.luogoEsteso.sigla;
        }

      } */
    });
    self.model.metadata.riUserG = riUserG;
    if (self.model.metadata.riUserF.listaPf.length > 0 && self.model.metadata.riUserF.listaPf != null) {
      self.model.metadata.riUserF.listaPf[0].residenza = Residenza.build(riUserG.sedeLegale);
    }
    self.model.metadata.callToCervedDone = true;
    self.validatePage();
  }

  self.updateModel = function (riUserG, result, formaGiuridica) {
    if (riUserG) {

      self.model.metadata.riUserG = RiUserG.build(riUserG);

      if (result === true && ($giuridicVersion.checkIfInd(formaGiuridica) || formaGiuridica === 'PEF')) {
        self.dittaIndividualeHasValidRiUserG = true;
        if (self.model.metadata.riUserG.ndg) {
          self.validatePage();
        }
      } else if (result === true && !$giuridicVersion.checkIfInd(formaGiuridica) && formaGiuridica !== 'PEF') {
        self.validatePage();
      } else {
        self.invalidatePage();
      }

      console.log("upddate RiUserG model: ", self.model.metadata.riUserG);

      self.checkOptional(riUserG, result);
    }
  };

  self.updateModelRiUserF = function (riUserF, result) {

    if (riUserF) {

      self.model.metadata.riUserF = RiUserF.build(riUserF);

      if (self.dittaIndividualeHasValidRiUserG && result) {
        self.validatePage();
      } else {
        self.invalidatePage();
      }

      console.log("upddate RiUserF model: ", self.model.metadata.riUserF);

    }
  }

  self.goBackFromCerved = function () {
    self.showCervedInfos = false;
  };

  self.goToUpdateFromCerved = function (showUpdateFromCerved, nsil) {
    if (showUpdateFromCerved === true) {
      self.showCervedInfos = true;
      self.supportModel.callToCerved = true;
    } else {
      self.supportModel.callToCerved = false;
      self.showCervedInfos = false;
    }
    if (nsil) {
      self.modifyTestModalInNsil = true;
    } else {
      self.modifyTestModalInNsil = false;
    }
  };

  self.retrieveCervedData = function (cervedData) {
    self.supportModel.riUserGFromCerved = cervedData;
  };

  self.backButtonIsVisble = function (backButton) {
    self.supportModel.isBackButton = backButton;
  };

  self.isReturnedDataFromCerved = function (isCervedData) {

    if (isCervedData) {
      self.cervedDataOk({
        isCervedDataOk: true
      })
      self.validatePage();
    } else {
      self.cervedDataOk({
        isCervedDataOk: false
      })
      self.invalidatePage();
    }
  }

  self.fattElettronica = function (value, result) {
    if (result === true) {
      self.model.metadata.riUserG.sedeFatturazione.fatturazione = value;
      console.log("Fatturazione: ", self.model);
    }
  }

  self.cervedRestFinish = function (value) {
    self.supportModel.callToCerved = !value;
  }
  self.checkOptional = function (riUserG, result) {
    if (result == false) {
      if (riUserG.cciaa != null && riUserG.cciaaPv == null) {
        self.cciaaPvIsOptional = true;
      } else {
        self.cciaaPvIsOptional = false;
      }
    }
  }
}